import {FC} from 'react';
import {useField} from 'formik';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {TShow} from '../../../../../hooks/useShow';
import {RootState} from '../../../../../redux/store.type';
import {TSlot} from '../../../../../redux/timetable/timetable.type';
import DisabledInput from '../../../../../component/input/disabledInput/DisabledInput';
import {getDateFormat} from '../../../../../library/dates';
import * as css from './TimeSlotField.css';

const formatTime = (timeStart: number) => getDateFormat(timeStart, 'HH:mm');

interface TimeSlotFieldProps {
    show: TShow;
    name?: string;
    label?: string;
    disabled?: boolean;
}

const TimeSlotField: FC<TimeSlotFieldProps> = ({show, name = 'tsid', label, disabled = false}) => {
    const {t} = useTranslation('timetable');
    const [field, meta] = useField<number | null>(name);
    const slots = useSelector((state: RootState) => state.timetable.slots);

    const selected = slots.find((s: TSlot) => s.tsid === field.value);
    const hasError = !disabled && !!(meta.touched && meta.error);

    const toggle = () => { if(show.isOpen) show.close(); else show.open(); };

    return (
        <css.wrap className={disabled ? 'disabled' : ''}>
            <DisabledInput
                text={label ?? t('timeSlot')}
                placeholder="00:00"
                icon="hourglassOutline"
                value={selected ? formatTime(selected.timeStart) : ''}
                events={disabled ? {} : {onClick: toggle}}
                className=""
                dataCyName=""
                hasArrow
                invalid={hasError}
            />
            {hasError && <css.errorText>{meta.error}</css.errorText>}
        </css.wrap>
    );
};

export default TimeSlotField;
